module.exports = __webpack_public_path__ + "static/img/blue_dark_circle.d7db60e4.png";